export const FINANCE_FORM_NAME = 'finance-application'
export const REQUEST_FINANCE_QUOTES = '@FINANCE/REQUEST_FINANCE_QUOTES'
export const RECEIVE_FINANCE_QUOTES = '@FINANCE/RECEIVE_FINANCE_QUOTES'
export const ERROR_FINANCE_QUOTES = '@FINANCE/ERROR_FINANCE_QUOTES'
export const RECEIVE_FINANCE_DECISION = '@FINANCE/RECEIVE_FINANCE_DECISION'
export const REQUEST_INDICATIVE_APR = '@FINANCE/REQUEST_INDICATIVE_APR'
export const RECEIVE_INDICATIVE_APR = '@FINANCE/RECEIVE_INDICATIVE_APR'
export const ERROR_INDICATIVE_APR = '@FINANCE/ERROR_INDICATIVE_APR'

export const REQUEST_DEPOSIT_RANGE = '@FINANCE/REQUEST_DEPOSIT_RANGE'
export const RECEIVE_DEPOSIT_RANGE = '@FINANCE/RECEIVE_DEPOSIT_RANGE'
export const ERROR_DEPOSIT_RANGE = '@FINANCE/ERROR_DEPOSIT_RANGE'
